export default __webpack_public_path__ + "static/media/Sofiia.7f973444.jpg";